import {
	IconPersons,
	IconEvent,
	IconCompany,
	IconLayers,
	Text,
	IconSliders,
} from '@montel/montelpro-shared-components-v2';
import { TMenuItem } from '../../components/common/Menu';
import { AdminRole } from 'domain/account/enums';

const sideMenuConfig: TMenuItem[] = [
	{
		type: 'Clickable',
		text: 'Montel Account',
		link: '/accounts',
		icon: <IconPersons color="textSubtle" boxSize="24px" />,
		isEnd: false,
	},
	{
		type: 'Clickable',
		text: 'System entities',
		link: '/systementities',
		icon: <IconLayers color="textSubtle" boxSize="24px" />,
		isEnd: false,
	},
	{
		type: 'Clickable',
		text: 'Companies',
		link: '/companies',
		icon: <IconCompany color="textSubtle" boxSize="24px" />,
		isEnd: false,
	},
	{
		type: 'Separator',
	},
	{
		type: 'Clickable',
		text: 'Alerts',
		link: '/alerts',
		icon: <Text>AL</Text>,
		isEnd: false,
	},
	{
		type: 'Clickable',
		text: 'EnAppSys',
		link: '/enappsys',
		icon: <Text>EN</Text>,
		isEnd: false,
	},
	{
		type: 'Clickable',
		text: 'FlexInsight',
		link: '/flex-insight',
		icon: <Text>FI</Text>,
		isEnd: false,
	},
	{
		type: 'Clickable',
		text: 'News Page',
		link: '/newspage/users',
		icon: <Text>NE</Text>,
		isEnd: false,
	},
	{
		type: 'Clickable',
		text: 'Energy Quantified',
		link: '/energy-quantified',
		icon: <Text>EQ</Text>,
		isEnd: false,
	},
	{
		type: 'Clickable',
		text: 'Montel Markets',
		link: '/markets',
		icon: <Text>MM</Text>,
		isEnd: false,
	},
	{
		type: 'Clickable',
		text: 'SysPower',
		link: '/syspower',
		icon: <Text>SP</Text>,
		isEnd: false,
	},
	{
		type: 'Clickable',
		text: 'Data Fabricator',
		link: '/data-fabricator',
		icon: <Text>DF</Text>,
		isEnd: false,
	},
	{
		type: 'Clickable',
		text: 'Montel PPA',
		link: '/montel-ppa',
		icon: <Text>MP</Text>,
		isEnd: false,
	},
	{
		type: 'Spacer',
	},
	{
		type: 'Clickable',
		text: 'Tools',
		link: '/tools',
		icon: <IconSliders color="textSubtle" boxSize="24px" />,
		isEnd: true,
	},
	{
		type: 'Clickable',
		text: 'Developer',
		link: '/developer',
		icon: <IconEvent color="textSubtle" boxSize="24px" />,
		isEnd: true,
		allowedRoles: [AdminRole.DEVELOPER],
	},
];

export default sideMenuConfig;
